import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=7c2d806e"
import script from "./Info.js?vue&type=script&lang=js&external"
export * from "./Info.js?vue&type=script&lang=js&external"
import style0 from "./Info.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports